import { DateRangePicker, DateRangePickerShape } from 'react-dates';
import { Breakpoints, Colors } from '../../shared/styles/StyleConst';
import { isEnglish } from '../../config/locales/i18n';

type WAmazingDateRangePickerProps = DateRangePickerShape & {
  withoutPrice?: boolean;
};

const closeButtonScale = 24 / 15;

export default function WAmazingDateRangePicker({
  withoutPrice,
  ...rest
}: WAmazingDateRangePickerProps) {
  return (
    <>
      <DateRangePicker {...rest} />
      <style jsx global>
        {`
          .DateRangePicker_picker {
            z-index: 1001;
          }
          .CalendarDay__firstDayOfWeek {
            color: ${isEnglish() ? '#333333' : '#4fa3fa'};
          }
          .CalendarDay__lastDayOfWeek {
            color: #4fa3fa;
          }
          .CalendarDay__selected,
          .CalendarDay__selected_span {
            color: #fff !important;
          }
          .CalendarDay__blocked_out_of_range {
            color: #a8a8a8 !important;
            background-color: #fafafa !important;
          }
          @media screen and (max-width: ${Breakpoints.xsMax}) {
            .DateRangePicker_picker {
              position: fixed;
              top: 50% !important;
              left: 50% !important;
              transform: translate(-50%, -50%);
            }
            .DayPicker_focusRegion {
              height: ${withoutPrice ? 500 : 450}px;
            }
            .DateRangePicker_picker__fullScreenPortal {
              background-color: rgba(0, 0, 0, 0.6);
            }
            .DayPickerNavigation_button {
              border-radius: 50%;
              padding: 6px;
            }
            .DayPickerNavigation_button__default:active {
              background: #f2f2f2;
            }
            .DayPickerNavigation_button__disabled {
              background: ${Colors.white} !important;
            }
            .CalendarDay__selected,
            .CalendarDay__selected_span {
              background-color: #f06083 !important;
              border: 1px solid #f06083 !important;
            }
            .calendar-info {
              padding: 20px 10px;
            }
            .DayPicker_portal__horizontal {
              transform: translate(0, ${withoutPrice ? '-50%' : '-60%'});
              margin-top: 0 !important;
            }
            .DateRangePicker_closeButton {
              top: calc(50% - ${withoutPrice ? 500 / 2 : 520 / 2}px);
              transform: translate(0, ${-100 * (1 + (closeButtonScale - 1) / 2)}%)
                scale(${closeButtonScale});
            }
            .DayPicker_weekHeader_li {
              background-color: ${Colors.gray100};
              padding: 10px 0;
            }
            .CalendarMonth_table {
              margin-top: 20px;
            }
            .DayPickerNavigation_leftButton__horizontalDefault {
              left: ${rest.daySize ? `calc(50% - ${(rest.daySize * 7) / 2}px` : '10px'};
            }
            .DayPickerNavigation_rightButton__horizontalDefault {
              right: ${rest.daySize ? `calc(50% - ${(rest.daySize * 7) / 2}px` : '10px'};
            }
          }
        `}
      </style>
    </>
  );
}
